const HOLDER_TYPE_ENUM = {
  COMPANY: 'company',
  INDIVIDUAL: 'individual'
}

const isCompany = holderType =>
  holderType.toLowerCase() === HOLDER_TYPE_ENUM.COMPANY.toLowerCase()
const isIndividual = holderType =>
  holderType.toLowerCase() === HOLDER_TYPE_ENUM.INDIVIDUAL.toLowerCase()

export { HOLDER_TYPE_ENUM, isCompany, isIndividual }
